/**
 * ===========================================
 * StudySpace ERP Frontend - Auth API
 * ===========================================
 * 
 * API methods for authentication.
 * 
 * @file src/api/auth.js
 * @description Authentication API endpoints
 */

import axiosInstance from './axios';

/**
 * Register a new user
 * @param {Object} userData - User registration data
 * @returns {Promise<Object>} Response data
 */
export const register = async (userData) => {
  const response = await axiosInstance.post('/auth/register', userData);
  return response.data;
};

/**
 * Login user
 * @param {Object} credentials - { email, password }
 * @returns {Promise<Object>} Response data
 */
export const login = async (credentials) => {
  const response = await axiosInstance.post('/auth/login', credentials);
  return response.data;
};

/**
 * Get current user profile
 * @returns {Promise<Object>} Response data
 */
export const getMe = async () => {
  const response = await axiosInstance.get('/auth/me');
  return response.data;
};

/**
 * Logout user
 * @returns {Promise<Object>} Response data
 */
export const logout = async () => {
  const response = await axiosInstance.post('/auth/logout');
  return response.data;
};
